// This is a module used for helper functions for building CVCQL profiles

import { CVCQL_VERSION } from "@/helpers/constants";

// interface ProfileMetadataFlags {
//   deleted: Boolean;
//   released: Boolean;
// }

// interface ProfileMetadataAnnotations {
//   "insights/display-name": string;
//   "insights/last-updated": string;
// }

// /**
//  * ProfileMetadataArgs is used only in buildProfile function for the metadata
//  * arguments. It's only difference from ProfileMetadata is that some variables
//  * are optional (and set in buildProfile)
//  */
// interface ProfileMetadataArgs {
//   name: string;
//   cvcql_version?: string;
//   flags?: ProfileMetadataFlags;
//   annotations?: ProfileMetadataAnnotations;
//   tags?: Array<string>;
//   expires?: string;
//   update_every?: Number;
// }

// interface ProfileMetadata {
//   name: string;
//   cvcql_version: string;
//   flags: ProfileMetadataFlags;
//   annotations: ProfileMetadataAnnotations;
//   tags: Array<string>;
//   expires: string;
//   update_every: Number;
// }

// /**
//  * Profile payload which matches what should be sent to the Insights API
//  */
// interface Profile {
//   metadata: ProfileMetadata;
//   query: Object;
// }

/**
 * buildProfile builds a CVCQL profile ready to send to the Insights API
 * @param query CVCQL query object
 * @param metadata Metadata with defaults if fields are not specified
 * @returns A complete CVCQL profile ready to send to the Insights API
 */
export function buildProfile(query, metadata) {
  if (metadata.annotations === undefined) metadata.annotations = {}
  if (
    typeof metadata.annotations === "object" &&
    !metadata.annotations["insights/last-updated"]
  ) {
    metadata.annotations["insights/last-updated"] = new Date().toISOString();
  }
  if (
    typeof metadata.annotations === "object" &&
    !metadata.annotations["insights/display-name"]
  ) {
    metadata.annotations["insights/display-name"] = metadata.name;
  }
  
  // TODO somehow check that the query matches the carefully managed JSON
  // Schema found in CvcqlJsonSchema.js

  return {
    metadata: {
      name: metadata.name,
      cvcql_version: metadata.cvcql_version ?? CVCQL_VERSION,
      flags: metadata.flags ?? { deleted: false, released: true },
      annotations: metadata.annotations,
      tags: metadata.tags ?? [],
      expires: metadata.expires,
      update_every: metadata.update_every,
    },
    query: query,
  };
}
